































import {Component, Prop, Vue} from "vue-property-decorator";
import {TrainRecordDto, VolunteerServiceHistoryDto} from "../../api/appService";
import api from "@/api";

@Component({
  name: "VolunteerTrainRecordHistoryTimeline",
})
export default class VolunteerTrainRecordHistoryTimeline extends Vue {
  @Prop({required: false, default: 0})
  volunteerId!: number;

  @Prop({required: false, default: []})
  histories!: TrainRecordDto[];

  loading = false;

  created() {
    if (this.volunteerId) {
      this.loading = true;
      this.loadHistories();
    } else {
      this.loading = false;
    }
  }

  loadHistories() {
    api.trainRecord
      .getAll({volunteerId: this.volunteerId})
      .then((res) => {
        this.histories = res.items!;
        this.loading = false;
      });
  }
}
